import { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { connect } from 'react-redux'
import { isNil } from 'lodash'
import { Link, useLocation, useNavigate } from 'react-router-dom'

import routes from '../../routers'
import Header from '../Header'
import Footer from '../Footer'
import ProductUpdatesBanner from '../ProductUpdatesBanner'
import InstallAppBanner from '../InstallAppBanner'
import CardExpiryBanner from '../CardExpiryBanner'
import { ChristmasCountdown } from '../CookbookPromo'
import { rememberReturnPath } from '../../utils/returnTo'

// The recipe form's pages: no promotions there, and the phone install banner would cover
// the Save and Next buttons
const RECIPE_FORM_PAGES = [routes.addRecipe, routes.addRecipeSecond, routes.addRecipeThird]

// allowGuests: a page people can open without signing in (a gift link, the gift page);
// they see a plain top bar with the logo and a sign-in link
const GuestHeader = () => (
  <div className="innerHeaderComponent">
    <header className="header">
      <div className="headerInner headerContainer">
        <Link className="innerLogoSite" to={routes.signIn}>
          <img src="/logo.svg" alt="Morsel" className="headerLogo" />
        </Link>
        <Link to={routes.signIn} className="inviteBtn">
          Sign in
        </Link>
      </div>
    </header>
  </div>
)

const Layout = ({ user, title, children, allowGuests = false }) => {
  const navigate = useNavigate()
  const { pathname, search } = useLocation()
  const guest = isNil(user)
  // No recipes yet: keep the page about adding the first one, without the cookbook
  // promotions and the install banner competing for attention
  const firstRecipeStillToCome = !guest && Number(user?.recipes_count || 0) === 0
  // Nor while someone is writing a recipe
  const onRecipeForm = RECIPE_FORM_PAGES.includes(pathname)
  const quietPage = firstRecipeStillToCome || onRecipeForm

  useEffect(() => {
    if (!allowGuests && guest) {
      rememberReturnPath(`${pathname}${search}`)
      navigate(routes.signIn)
    }
  }, [user])

  return (
    <div>
      <Helmet>
        <title>{title} - Morsel</title>
        <meta property="og:title" content={title} key="title" />
      </Helmet>

      {guest ? (
        <GuestHeader />
      ) : (
        <>
          <CardExpiryBanner />
          {quietPage ? null : <ProductUpdatesBanner />}
          <Header />
          {quietPage ? null : <ChristmasCountdown />}
        </>
      )}
      {children}
      {guest ? null : <Footer />}
      {guest || quietPage ? null : <InstallAppBanner />}
    </div>
  )
}

export default connect(({ user }) => ({ user: user.data }))(Layout)
